import { mat3, quat, vec3 } from 'gl-matrix';

import type { Centerline, Vec3 } from '../domain';

export interface VtkCPRCenterline {
    position: number[];
    orientation: number[]; // quaternion [x,y,z,w] per node
}

/**
 * Convert a domain Centerline into vtkImageCPRMapper input format.
 */
export function toVtkCPR(centerline: Centerline): VtkCPRCenterline {
    const positions: number[] = [];
    const orientations: number[] = [];

    for (let i = 0; i < centerline.nodeCount; i++) {
        const node = centerline.getNodeAt(i);

        const { point, up, normal } = node;

        // Push world position
        positions.push(point[0], point[1], point[2]);

        // ---- Build orthonormal frame ----
        const tangent = vec3.normalize(vec3.create(), normal as Vec3);
        const upVec = vec3.normalize(vec3.create(), up as Vec3);

        const right = vec3.create();
        vec3.cross(right, upVec, tangent);
        vec3.normalize(right, right);

        // Re-orthogonalize up (safety)
        vec3.cross(upVec, tangent, right);
        vec3.normalize(upVec, upVec);

        // ---- Build rotation matrix (columns: right, up, tangent) ----
        const m = mat3.fromValues(
            right[0],
            right[1],
            right[2],
            upVec[0],
            upVec[1],
            upVec[2],
            tangent[0],
            tangent[1],
            tangent[2]
        );

        // ---- Convert to quaternion ----
        const q = quat.create();
        quat.fromMat3(q, m);
        quat.normalize(q, q);

        orientations.push(q[0], q[1], q[2], q[3]);
    }

    return {
        position: positions,
        orientation: orientations,
    };
}
